define([
    'basecollection',
    'modules/timezones/models/timezone'
], (BaseCollection, TimeZone) => BaseCollection.extend({
    model: TimeZone,
    url: '/repos/timezones'
}));
